<header>
    <div class="layout-header-full fixed-top">
        <app-header-full></app-header-full>
    </div>
</header>

<q-sub-navbar></q-sub-navbar>

<div class="container-fluid layout-container">
    <!-- Main Body/Content -->
    <div class="row">
        <div class="col">
            <div class="layout-content-wrapper">
                <ng-content></ng-content>
            </div>
        </div>
    </div>
</div>

<q-footer [ver]="version" [bussAppUrl]="businessAppUrl" [isLight]="false">
</q-footer>
